import {
  AppstoreAddOutlined,
  EnvironmentOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import CountinueOnMobileApp from "apps/Common/CountiueOnMobileApp";
import { hanldleSetRealStateViewingMode } from "apps/RealState/ListItems/ClientStates";

const MobileViewingModes = () => {
  const { viewingModes } = useSelector((state: RootState) => state.realState);
  const dispatch = useDispatch();

  return (
    <div className="p-3 rounded-md flex flex-col gap-2 justify-center items-center w-full mx-auto">
      <span
        className={`hover:cursor-pointer flex gap-1 p-2 border border-gray-300 rounded-md w-full items-center justify-center transition ${
          viewingModes === "cart" ? "!bg-gray-200" : ""
        }`}
        onClick={() =>
          dispatch(hanldleSetRealStateViewingMode({ viewingMode: "cart" }))
        }
      >
        <AppstoreAddOutlined
          className={`text-xl ${
            viewingModes === "cart" ? "text-black" : "text-gray-400"
          }`}
        />
        <span className="text-xs">Kart Görünüm</span>
      </span>

      <span
        className={`hover:cursor-pointer flex gap-1 p-2 border border-gray-300 rounded-md w-full justify-center items-center  transition ${
          viewingModes === "list" ? "!bg-gray-200" : ""
        }`}
        onClick={() =>
          dispatch(hanldleSetRealStateViewingMode({ viewingMode: "list" }))
        }
      >
        <UnorderedListOutlined
          className={`text-xl ${
            viewingModes === "list" ? "text-black" : "text-gray-400"
          }`}
        />
        <span className="text-xs">Liste Görünüm</span>
      </span>

      <span
        className={`hover:cursor-pointer flex gap-1 p-2 border border-gray-300 rounded-md w-full justify-center items-center  transition ${
          viewingModes === "map" ? "!bg-gray-200" : ""
        }`}
        onClick={() =>
          dispatch(hanldleSetRealStateViewingMode({ viewingMode: "map" }))
        }
      >
        <EnvironmentOutlined
          className={`text-xl ${
            viewingModes === "map" ? "text-black" : "text-gray-400"
          }`}
        />
        <span className="text-xs">Harita Görünüm</span>
      </span>

      {viewingModes === "map" && (
        <CountinueOnMobileApp
          desc="İlanları harita üzerinde görüntüleyebilmek için mobil uygulamamızı kullanınız"
          isShowChildren={true}
          isShowDesc={false}
        >
          <></>
        </CountinueOnMobileApp>
      )}
    </div>
  );
};

export default MobileViewingModes;
